import { makeObservable, observable } from 'mobx'
import type { CheckableColl } from 'src/models/CheckableColl'

import { DTO } from '../DTO'
import type { LectureInfo } from './LectureInfo'

export class LectureInfoGroup extends DTO {
  lectureColls: CheckableColl<LectureInfo>

  constructor(data: Omit<LectureInfoGroup, 'update' | 'updateExceptNullable' | 'toJS'>) {
    super()
    makeObservable(this, {
      lectureColls: observable,
    })

    this.lectureColls = data.lectureColls
  }
}
